import { LDFlagsService } from '@degreed/lxp/services';
import { AuthUser } from '@degreed/lxp/services/authorization';
import {
  OrgInfo,
  OrgPermissions,
  OrgSettings,
} from '@degreed/lxp/services/org';

/** The fields of an `orgInfo` entry that `canManageSkillInference` reads. */
type SkillInferenceOrg = Pick<OrgInfo, 'organizationId'> & {
  settings?: Pick<OrgSettings, 'enableSkillsPlatform'>;
  permissions?: Pick<OrgPermissions, 'manageSkills' | 'downloadReports'>;
};

/**
 * Whether the user may manage Skill Inference for `orgId`. Shared by `ManageSkillInferenceGuard`
 * (called with the URL org) and `provideGdAccess` (called with the user's default org).
 */
export function canManageSkillInference(
  authUser:
    | (Pick<AuthUser, 'enableBulkSkillInferenceForContent'> & {
        orgInfo: readonly SkillInferenceOrg[];
      })
    | null
    | undefined,
  orgId: number | undefined,
  ldFlags: { skills: Pick<LDFlagsService['skills'], 'manageSkillInference'> }
): boolean {
  const orgInfo = authUser?.orgInfo?.find(
    (org) => org.organizationId === orgId
  );

  return (
    !!ldFlags.skills.manageSkillInference &&
    !!orgInfo?.settings?.enableSkillsPlatform &&
    !!authUser?.enableBulkSkillInferenceForContent &&
    !!orgInfo?.permissions?.manageSkills &&
    !!orgInfo?.permissions?.downloadReports
  );
}
